import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import AddMobileAppLinkForm
  from 'components/dashboard/mobile-app-links/AddMobileAppLinkForm';
import MobileAppsLinksList
  from 'components/dashboard/mobile-app-links/MobileAppsLinksList';

import './MobileAppLinksContent.css';

const MobileAppLinksContent = props => {
  const { me } = props;
  const { t } = useTranslation();

  return (
    <div className="mobile-app-links-content__component">
      {/* Add Mobile Apps Links Form  */}
      <DashboardFormSection
        proLabel
        header={t("MOBILE APP LINKS")}
      >
        <div className="add-apps-forms">
          <AddMobileAppLinkForm
            key="add-mobile-app-link-form-key-ios"
            type="ios"
          />

          <AddMobileAppLinkForm
            key="add-mobile-app-link-form-key-android"
            type="android"
          />
        </div>
      </DashboardFormSection>

      {/* Mobile Apps Links List */}
      {me && me.subscription && me.subscription.ff_mobile_app_links &&
        <MobileAppsLinksList />
      }
    </div>
  );
};

MobileAppLinksContent.propTypes = {
  me: PropTypes.object,
};

MobileAppLinksContent.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {},
)(MobileAppLinksContent);
